const myProjects = {
  //id.1 MY PORTOFOLIO
  id_1_project_name: "myProjects.id_1.project_name",
  id_1_desc: "myProjects.id_1.desc",
  //id.2 SILVER PROTECT
  id_2_project_name: "myProjects.id_2.project_name",
  id_2_desc: "myProjects.id_2.desc",
  //id.3 SAM ESQUIRE BARBER SHOP
  id_3_project_name: "myProjects.id_3.project_name",
  id_3_desc: "myProjects.id_3.desc",
  //id.4 NLB REAL ESTATE
  id_4_project_name: "myProjects.id_4.project_name",
  id_4_desc: "myProjects.id_4.desc",
  //RESURRECTION MIRACLE CENTER CHURCH
  id_5_project_name: "myProjects.id_5.project_name",
  id_5_desc: "myProjects.id_5.desc",
  //id.6 TEMPLO MONTE HOREB
  id_6_project_name: "myProjects.id_6.project_name",
  id_6_desc: "myProjects.id_6.desc",
  //id.7 MI ALEGRIA FAMILY DAYCARE
  id_7_project_name: "myProjects.id_7.project_name",
  id_7_desc: "myProjects.id_7.desc",
  // id.8 CIUDADANOS UNIDOS
  id_8_project_name: "myProjects.id_8.project_name",
  id_8_desc: "myProjects.id_8.desc",
  // id.9 CENTRO DE REHABILITACION NUEVA CREACION
  id_9_project_name: "myProjects.id_9.project_name",
  id_9_desc: "myProjects.id_9.desc",

  //id.10 HOTEL PLAZA NARDOS
  id_10_project_name: "myProjects.id_10.project_name",
  id_10_desc: "myProjects.id_10.desc",

  //id.11 TRIPYTOUR BLOG
  id_11_project_name: "myProjects.id_11.project_name",
  id_11_desc: "myProjects.id_11.desc",

  //id.12 CLEAN AID PLUS

  id_12_project_name: "myProjects.id_12.project_name",
  id_12_desc: "myProjects.id_12.desc",

  //id.13 ACADEMLO LIBRARY
  id_13_project_name: "myProjects.id_13.project_name",
  id_13_desc: "myProjects.id_13.desc",

  //id.14 AGENCIA DE TOURS
  id_14_project_name: "myProjects.id_14.project_name",
  id_14_desc: "myProjects.id_14.desc",

  //id.15 OTHER PROJECTS
  id_15_project_name: "myProjects.id_15.project_name",
  id_15_desc: "myProjects.id_15.desc",

  // id_9_aliasInstitution: "myProjects.id_9.aliasInstitution",
  id_11_seeCerts: "myProjects.id_11.seeCerts",
  aliasInstitution: "myProjects.aliasInstitution",
  seeCert: "myProjects.seeCert",
};

export const projects = [
  //id.1 MY PORTOFOLIO
  // {
  //   id: 1,
  //   project_name: `${myProjects.id_1_project_name}`,
  //   src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F1.v2.oscarmorenoportfolio.png?alt=media&token=e255f12d-c04b-4682-8b32-14fdec4a99cd",
  //   alt: "Oscar Moreno Portfolio",
  //   desc: `${myProjects.id_1_desc}`,
  //   href: "https://oscarmorenodev.vercel.app//projects",
  //   //Deployment section

  //   //Vercel
  //   deploy_icon_1:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
  //   deploy_name_1: "Vercel",
  //   // git hub repo
  //   git_icon: "https://www.svgrepo.com/show/217753/github.svg",
  //   git_url: "https://github.com/OzkrMebasser/oscar-reactjs-portfolio",
  //   git_name: "Git repository",
  //   www_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
  //   www_site: "https://oscarmorenodev.vercel.app//projects",

  //   //Stack I used Section
  //   /*Icons alt names*/
  //   tech_1_name: "HTML-5",
  //   tech_2_name: "CSS-3",
  //   tech_3_name: "JavaScript",
  //   tech_4_name: "React Js",
  //   tech_5_name: "Boostrap",
  //   tech_6_name: "i18next",

  //   deployed: true,
  //   type: "online",

  //   /*Icons images*/

  //   tech_1_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
  //   tech_2_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
  //   tech_3_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
  //   tech_4_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
  //   tech_5_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fbootstrap.svg.svg?alt=media&token=d2cd69d3-f464-4646-8108-5fb9be6c3392",
  //   tech_6_icon:
  //     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fi18next.png?alt=media&token=84de9dec-afef-41a0-a233-7701bd1e5e27",
  // },
  //id.2 SILVER PROTECT
  {
    id: 2,
    project_name: `${myProjects.id_2_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F2.silverprotec.com.mx.png?alt=media&token=b3c22837-33ca-4036-acf7-71c9d172bab1",
    alt: "Silver Protect",
    desc: `${myProjects.id_2_desc}`,
    href: "https://silverprotect.com.mx/",

    //Deployment section
    //Firebase
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firabase",
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/silver-protect-website",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://silverprotect.com.mx/",

    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Tailwind CSS",
    tech_6_name: "Email JS",

    deployed: true,
    type: "online",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",

    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Femailjs.png?alt=media&token=e31be33a-174b-4860-8a75-44fcedb47b74",
  },
  //id.3 SAM ESQUIRE BARBER SHOP
  {
    id: 3,
    project_name: `${myProjects.id_3_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F3.samesquire.com.png?alt=media&token=e75c445f-f0ac-4f39-8b6d-10a8e5ae5841",
    alt: "SAM ESQUIRE BARBER SHOP",
    desc: `${myProjects.id_3_desc}`,
    href: "https://samesquire.com/",

    //Deployment section
    //Firebase
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firabase",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/sam-esquire-barbershop",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://samesquire.com/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "Swiper JS",
    tech_5_name: "AOS",

    deployed: true,
    type: "online",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FAOS.jpeg?alt=media&token=284f7e39-7d00-4c67-a4bd-fe5c5cb4896c",
  },
  //id.4 NLB REAL ESTATE
  {
    id: 4,
    project_name: `${myProjects.id_4_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F4.httpsnlbrealestate.com.png?alt=media&token=d71a0660-ea18-41a2-9c6e-36fee1dfc6bc",
    alt: "NLB REAL ESTATE",
    desc: `${myProjects.id_4_desc}`,
    href: "https://nlb-realestate.com/",
    //Deployment section

    //Firebase
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firebase",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/nlb-real-estate-nxtjs",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://nlb-realestate.com/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Tailwind",
    tech_6_name: "Next Js",
    tech_7_name: "i18next",

    deployed: true,
    type: "online",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fi18next.png?alt=media&token=84de9dec-afef-41a0-a233-7701bd1e5e27",
  },
  //id.5 RESURRECTION MIRACLE CENTER
  {
    id: 5,
    project_name: `${myProjects.id_5_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F5.b-resurrection-miracle-center.png?alt=media&token=4237a00e-c6e4-4df4-a36f-cf32671f3219",
    alt: "RESURRECTION MIRACLE CENTER CHURCH",
    desc: `${myProjects.id_5_desc}`,
    href: "https://www.resurrectionmiraclecenterchurch.org",

    //Deployment section
    //Firebase
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firebase",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/RMCC",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://www.resurrectionmiraclecenterchurch.org/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "Tailwind",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Next Js",
    tech_6_name: "Swiper JS",
    tech_7_name: "AOS",

    deployed: true,
    type: "online",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FAOS.jpeg?alt=media&token=284f7e39-7d00-4c67-a4bd-fe5c5cb4896c",
  },
  //id.6 TEMPLO MONTE HOREB
  {
    id: 6,
    project_name: `${myProjects.id_6_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F6.b.templomontehoreb.png?alt=media&token=d10003aa-5d0e-4c7b-990f-7672ab943184",
    alt: "TEMPLO MONTE HOREB",
    desc: `${myProjects.id_6_desc}`,
    href: "https://www.templomontehoreb.com",

    //Deployment section
    // Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "Vercel",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/templo-monte-horeb",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://www.templomontehoreb.com/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "Tailwind",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Next Js",
    tech_6_name: "Swiper JS",
    tech_7_name: "AOS",

    deployed: true,
    type: "online",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FAOS.jpeg?alt=media&token=284f7e39-7d00-4c67-a4bd-fe5c5cb4896c",
  },
  // id.7 MI ALEGRIA FAMILY DAYCARE
  {
    id: 7,
    project_name: `${myProjects.id_7_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F7.b.mialegriadaycare.png?alt=media&token=bb52e5f7-d8cb-470c-a6ce-057296d8d373",
    alt: "MI ALEGRIA FAMILY DAYCARE",
    desc: `${myProjects.id_7_desc}`,
    href: "https://mialegriadaycare.ca",

    //Deployment section
    //Firebase
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firabase",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/mi-alegria-daycare",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://mialegriadaycare.ca/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML5",
    tech_2_name: "Tailwind CSS",
    tech_3_name: "JavaScript",
    tech_4_name: "React JS",
    tech_5_name: "Next JS",
    tech_6_name: "TypeScript",
    tech_7_name: "Swiper JS",

    deployed: true,
    type: "online",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftypescript-icon-svgrepo-com.svg?alt=media&token=a9ca7b36-982d-420d-8a88-1d579d7dc18a",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
  },
  // id.8 CIUDADANOS UNIDOS
  {
    id: 8,
    project_name: "CIUDADANOS UNIDOS",
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F8.bciudadanosunidos.com.mx.png?alt=media&token=83cbbd5e-c503-4f7b-8b9d-62996d8cbdb5",
    alt: "CIUDADANOS UNIDOS",
    desc: `${myProjects.id_8_desc}`,
    href: "https://ciudadanosunidos.com.mx/",

    // Deployment section
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fwordpress-svgrepo-com.svg?alt=media&token=b537352d-cda5-4c99-84ae-319fd6a6ffdb",
    deploy_name_1: "WordPress",
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://ciudadanosunidos.com.mx/",

    //  Stack I used Section
    tech_1_name: "HTML5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "WordPress",
    tech_5_name: "Gutenberg",
    tech_6_name: "Jetpack",

    deployed: true,
    type: "online",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",

    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fwordpress-svgrepo-com.svg?alt=media&token=b537352d-cda5-4c99-84ae-319fd6a6ffdb",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fgutenberg-wordpress-768x402.jpg?alt=media&token=66546ad3-70a4-4719-be21-c890e3d799d9",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjetpack.png?alt=media&token=25a49c22-acb9-4360-84a7-b9feab128c37",
  },
  //id.9 CENTRO DE REHABILITACION NUEVA CREACION
  {
    id: 9,
    project_name: `${myProjects.id_9_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F9.b.centrorehabilitadornuevacreacion.org.png?alt=media&token=6d4d1776-b601-401d-ac05-ec20cc6349ca",
    alt: "CENTRO DE REHABILITACION NUEVA CREACION",
    desc: `${myProjects.id_9_desc}`,
    href: "https://centrorehabilitadornuevacreacionac.org/",

    // Deployment section
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
    deploy_name_1: "Firebase",
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/nueva-creacion-rehab-center",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://centrorehabilitadornuevacreacionac.org/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML5",
    tech_2_name: "Tailwind CSS",
    tech_3_name: "TypeScript",
    tech_4_name: "React JS",
    tech_5_name: "Next JS",
    tech_6_name: "AOS",
    tech_7_name: "EmailJS",

    deployed: true,
    type: "online",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftypescript-icon-svgrepo-com.svg?alt=media&token=a9ca7b36-982d-420d-8a88-1d579d7dc18a",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FAOS.jpeg?alt=media&token=284f7e39-7d00-4c67-a4bd-fe5c5cb4896c",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Femailjs.png?alt=media&token=e31be33a-174b-4860-8a75-44fcedb47b74",
  },
  //id.10 HOTEL PLAZA NARDOS
  {
    id: 10,
    project_name: "HOTEL PLAZA NARDOS",
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F10.hotel-plaza-nardos.png?alt=media&token=d4e83c7d-7510-4aa6-bb30-d7a105518936",
    alt: "HOTEL PLAZA NARDOS",
    desc: `${myProjects.id_10_desc}`,
    href: "https://plaza-nardos-hotel.vercel.app/",

    // Deployment section
    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/plaza-nardos-hotel",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://plaza-nardos-hotel.vercel.app/",
    // Stack I used Section
    tech_1_name: "HTML5",
    tech_2_name: "Tailwind CSS",
    tech_3_name: "JavaScript",
    tech_4_name: "React JS",
    tech_5_name: "Next JS",
    tech_6_name: "Swiper JS",
    tech_7_name: "EmailJS",

    deployed: true,
    type: "development",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Femailjs.png?alt=media&token=e31be33a-174b-4860-8a75-44fcedb47b74",
  },

  //id.11 CACI ALMA AC
  //id.12 IGLESIA NUEVA CREACION
  //id.13 BRISHOP

  // Example of the project object structure

  //   {
  //   id: 10,
  //   project_name: "",
  //   src: "",
  //   alt: "",
  //   desc: "",
  //   href: "",

  //   // Deployment section
  //   deploy_icon_1: "",
  //   deploy_name_1: "",
  //   git_icon: "",
  //   git_url: "",
  //   git_name: "",
  //   www_icon: "",
  //   www_site: "",

  //   // Stack I used Section
  //   tech_1_name: "",
  //   tech_2_name: "",
  //   tech_3_name: "",
  //   tech_4_name: "",
  //   tech_5_name: "",
  //   tech_6_name: "",

  //   deployed: false,
  //   type: "",

  //   tech_1_icon: "",
  //   tech_2_icon: "",
  //   tech_3_icon: "",
  //   tech_4_icon: "",
  //   tech_5_icon: "",
  //   tech_6_icon: "",
  // }

  // Example of the project object structure

  //   {
  //   id: 1,
  //   project_name: "",
  //   src: "",
  //   alt: "",
  //   desc: "",
  //   href: "",

  //   // Deployment section
  //   deploy_icon_1: "",
  //   deploy_name_1: "",
  //   git_icon: "",
  //   git_url: "",
  //   git_name: "",
  //   www_icon: "",
  //   www_site: "",

  //   // Stack I used Section
  //   tech_1_name: "",
  //   tech_2_name: "",
  //   tech_3_name: "",
  //   tech_4_name: "",
  //   tech_5_name: "",
  //   tech_6_name: "",

  //   deployed: false,
  //   type: "",

  //   tech_1_icon: "",
  //   tech_2_icon: "",
  //   tech_3_icon: "",
  //   tech_4_icon: "",
  //   tech_5_icon: "",
  //   tech_6_icon: "",
  // }

  //id.11 TRIPYTOUR BLOG
  {
    id: 11,
    project_name: `${myProjects.id_11_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F6.tripytour.blog.png?alt=media&token=5b8792fd-cbd8-44a5-8a58-c3a140922c24",
    alt: "TRIPYTOUR BLOG",
    desc: `${myProjects.id_11_desc}`,
    href: "https://tripytour-blog.vercel.app/",

    //Deployment section

    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "Vercel",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/tripytour-blog",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://tripytour-blog.vercel.app/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Next Js",
    tech_6_name: "Prisma",
    tech_7_name: "MongoDB",

    deployed: true,
    type: "development",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FPRISMA.png?alt=media&token=fc59e78c-6885-4d82-9243-076c630c983e",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmongodb-svgrepo-com.svg?alt=media&token=12d49f5f-5031-43e4-abd8-aa14ae07565a",
  },
  //id.12 CLEAN AID PLUS
  {
    id: 12,
    project_name: `${myProjects.id_12_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F5.cleanaidplus.ca.png?alt=media&token=4d59d4a0-8d46-4e52-b0fd-5a5eb15d0480",
    alt: "CLEAN AID PLUS",
    desc: `${myProjects.id_12_desc}`,
    href: "https://clean-aid-plus.vercel.app/",
    //Deployment section

    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "Vercel",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/clean-aid-plus",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://clean-aid-plus.vercel.app/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Tailwind",
    tech_6_name: "Next Js",
    tech_7_name: "Swiper",

    deployed: true,
    type: "development",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fswiper-logo.svg?alt=media&token=0cfb7375-4661-4036-ad96-8bd143b4ac41",
  },
  //id.13 ACADEMLO LIBRARY
  {
    id: 13,
    project_name: `${myProjects.id_13_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F7.academloslibrary.png?alt=media&token=a6e98d82-f5c9-4dd3-8640-5a310bdacf10",
    alt: "ACADEMLO's LIBRARY",
    desc: `${myProjects.id_13_desc}`,
    href: "https://academlo-library-system-v3.onrender.com/",

    //Deployment section
    deployed: true,
    linkSchool: `${myProjects.aliasInstitution}`,
    seeCert: `${myProjects.seeCert}`,
    type: "academic",
    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Frenderlogo.png?alt=media&token=fdad5cbe-e801-401b-9c88-e4f4b908e03a",
    deploy_name_1: "RENDER",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/academlo-library-system-v2",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://academlo-library-system-v3.onrender.com/",

    tech_1_name: "HTML-5",
    tech_2_name: "BOOTSTRAP",
    tech_3_name: "PYTHON",
    tech_4_name: "DJANGO",
    tech_5_name: "POSTGRESQL",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/prueba-context-ecommerce.appspot.com/o/html-svgrepo-com.svg?alt=media&token=e8fcd17b-c890-4418-b058-e274e446bfd9",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fbootstrap.svg.svg?alt=media&token=d2cd69d3-f464-4646-8108-5fb9be6c3392",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpython-svgrepo-com.svg?alt=media&token=dd35c257-b994-4350-8fb0-9226eb25e748",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fdjango-svgrepo-com.svg?alt=media&token=13b31f65-df6d-4986-84ea-2d6abd0cc8d2",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpostgresql-svgrepo-com%20(1).svg?alt=media&token=8294cc05-91ae-49c4-8418-d531fc8ca0b7",
  },
  //id.14 TOUR AGENCY ECOMMMERCE
  {
    id: 14,
    project_name: `${myProjects.id_14_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F8.touragency.ecommerce.png?alt=media&token=33ab71f5-6496-4250-92f1-e1ca8946b074",
    alt: "TOUR AGENCY ECOMMMERCE",
    desc: `${myProjects.id_14_desc}`,
    href: "https://oscar-ecommerce-context-reducer.netlify.app/",

    //Deployment section
    deployed: true,
    linkSchool: `${myProjects.aliasInstitution}`,
    seeCert: `${myProjects.seeCert}`,
    type: "academic",
    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url:
      "https://github.com/OzkrMebasser/ecommer-context-reducer-oscar-beta",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://oscar-ecommerce-context-reducer.netlify.app/",

    tech_1_name: "HTML-5",
    tech_2_name: "MATERIAL UI",
    tech_3_name: "REACT JS",
    tech_4_name: "REACT ROUTER",
    tech_5_name: "REACT SPRING",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/prueba-context-ecommerce.appspot.com/o/html-svgrepo-com.svg?alt=media&token=e8fcd17b-c890-4418-b058-e274e446bfd9",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmaterial-ui-svgrepo-com.svg?alt=media&token=d9f03156-d62b-43b4-8265-026d65cbca23",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freactspring.jpeg?alt=media&token=cc64a01c-85fe-4b3b-b34e-efc464130f26",
  },
  //id.15 OTHER PROJECTS
  {
    id: 15,
    project_name: `${myProjects.id_15_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F9.otherprojects.png?alt=media&token=b94d54a9-d3f6-45d9-808d-655f05b2d316",
    alt: "OTHER PROJECTS",
    desc: `${myProjects.id_15_desc}`,
    href: "/more-projects",

    //Deployment section
    deployed: true,
    linkSchool: `${myProjects.aliasInstitution}`,
    seeCert: `${myProjects.id_9_seeCerts}`,
    type: "academic",
    //Vercel
    // deploy_icon_1:
    //   "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    // deploy_name_1: "VERCEL",
    // // git hub repo
    // git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    // git_url:
    //   "https://github.com/OzkrMebasser/ecommer-context-reducer-oscar-beta",
    // git_name: "Git repository",
    // www_icon:
    //   "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    // www_site: "other-projects",

    tech_1_name: "HTML-5",
    tech_2_name: "CSS",
    tech_3_name: "JAVASCRIPT",
    tech_4_name: "REACT JS",
    tech_5_name: "NODE JS",
    tech_6_name: "NEXT JS",
    tech_7_name: "PYTHON",
    tech_8_name: "DJANGO",

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/prueba-context-ecommerce.appspot.com/o/html-svgrepo-com.svg?alt=media&token=e8fcd17b-c890-4418-b058-e274e446bfd9",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnodejs-1-logo-svgrepo-com.svg?alt=media&token=afa3c35d-425a-44d7-95bc-ca797548ba45",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
    tech_7_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpython-svgrepo-com.svg?alt=media&token=dd35c257-b994-4350-8fb0-9226eb25e748",
    tech_8_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fdjango-svgrepo-com.svg?alt=media&token=13b31f65-df6d-4986-84ea-2d6abd0cc8d2",
  },
  //
];

const myOtherProjects = {
  aliasInstitutionName: "myOtherProjects.aliasInstitutionName",
  aliasInstitutionTitle: "myOtherProjects.aliasInstitutionTitle",
  seeCert: "myOtherProjects.seeCert",
  notDeployed: "myOtherProjects.notDeployed",
  //id.1 WEATHER APP
  id_1_project_name: "myOtherProjects.id_1.project_name",
  id_1_desc: "myOtherProjects.id_1.desc",
  //id.2 GITHUB USERS
  id_2_project_name: "myOtherProjects.id_2.project_name",
  id_2_desc: "myOtherProjects.id_2.desc",
  //id.3 PHOTO GALLERY
  id_3_project_name: "myOtherProjects.id_3.project_name",
  id_3_desc: "myOtherProjects.id_3.desc",
  //id.4 TO-DOS APP
  id_4_project_name: "myOtherProjects.id_4.project_name",
  id_4_desc: "myOtherProjects.id_4.desc",
  //id.5 PENDINGS LIST
  id_5_project_name: "myOtherProjects.id_5.project_name",
  id_5_desc: "myOtherProjects.id_5.desc",
  //id.6 ECOMMERCE API
  id_6_project_name: "myOtherProjects.id_6.project_name",
  id_6_desc: "myOtherProjects.id_6.desc",
  //id.7 MOVIE API
  id_7_project_name: "myOtherProjects.id_7.project_name",
  id_7_desc: "myOtherProjects.id_7.desc",
  //id.8 TRIE TREE AUTOCOMPLETE
  id_8_project_name: "myOtherProjects.id_8.project_name",
  id_8_desc: "myOtherProjects.id_8.desc",
  //id.9 TRIE TREE AUTOCOMPLETE
  id_9_project_name: "myOtherProjects.id_9.project_name",
  id_9_desc: "myOtherProjects.id_9.desc",
  //id.10 SCHOOL WEBSITE MOCKUP
  id_10_project_name: "myOtherProjects.id_10.project_name",
  id_10_desc: "myOtherProjects.id_10.desc",
  //id.11 ROMANS NUMERAL CONVERTER
  id_11_project_name: "myOtherProjects.id_11.project_name",
  id_11_desc: "myOtherProjects.id_11.desc",
  //id.12 TECHIES TRIVIA (VANILLA JS)
  id_12_project_name: "myOtherProjects.id_12.project_name",
  id_12_desc: "myOtherProjects.id_12.desc",
  //id.13 PORTOFOLIO MOCKUP
  id_13_project_name: "myOtherProjects.id_13.project_name",
  id_13_desc: "myOtherProjects.id_13.desc",
  //id.14 PORTOFOLIO MOCKUP
  id_14_project_name: "myOtherProjects.id_14.project_name",
  id_14_desc: "myOtherProjects.id_14.desc",
  //id.15 CONTACTS APP REACT ROUTER V6
  id_15_project_name: "myOtherProjects.id_15.project_name",
  id_15_desc: "myOtherProjects.id_15.desc",
  //id.16 MEMORY CARD GAME /
  id_16_project_name: "myOtherProjects.id_16.project_name",
  id_16_desc: "myOtherProjects.id_16.desc",
};
export const otherProjects = [
  //id.1 WEATHER APP
  {
    id: 1,
    // project_name: `${myProjects.id_1_project_name}`,
    project_name: `${myOtherProjects.id_1_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F9.weatherapp.png?alt=media&token=85a706ed-d084-4fad-b9fa-2d979e75f3f8",
    alt: "WEATHER APP",
    desc: `${myOtherProjects.id_1_desc}`,
    href: "https://ozkr-weather-api.vercel.app/",
    //Deployment section

    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "Vercel",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/ozkr-weather-api",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://ozkr-weather-api.vercel.app/",
    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,
    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "React Router",
    tech_6_name: "Axios HTTP",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Flogoaxios.svg?alt=media&token=fcc440c0-5b4d-41d9-a4a4-0c6582d9f11b",
  },
  //id.2 GITHUB USERS
  {
    id: 2,
    // project_name: `${myProjects.id_1_project_name}`,
    project_name: `${myOtherProjects.id_2_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F10.githubusersapi.png?alt=media&token=2e51f521-2a59-4028-a675-bed0fe77ab67",
    alt: "github users",
    desc: `${myOtherProjects.id_2_desc}`,
    href: "https://github-user-oskr.vercel.app/",
    //Deployment section

    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "Vercel",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/GithubUserOskr",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://github-user-oskr.vercel.app/",
    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Tailwind",
    tech_6_name: "React Router",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
  },
  //id.3 PHOTO GALLERY
  {
    id: 3,
    project_name: `${myOtherProjects.id_3_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F11.galleriaunsplashapi.png?alt=media&token=ac403234-439a-4aab-a852-de17334ec704",
    alt: "photo gallery",
    desc: `${myOtherProjects.id_3_desc}`,
    href: "https://photos-galeria.vercel.app/",
    //Deployment section

    //Vercel
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/photos-galeria",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://photos-galeria.vercel.app/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Axios HTTP",

    deployed: true,
    type: "practice",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Flogoaxios.svg?alt=media&token=fcc440c0-5b4d-41d9-a4a4-0c6582d9f11b",
  },
  //id.4 TO-DOS APP
  {
    id: 4,
    project_name: `${myOtherProjects.id_4_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F12.todosapp.png?alt=media&token=e2efe097-d805-4a7a-913f-0e1cbce9b505",
    alt: "todos app",
    desc: `${myOtherProjects.id_4_desc}`,
    href: "https://to-do-pendings.netlify.app/",
    //Deployment section

    //NETLIFY
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnetlify-svgrepo-com.svg?alt=media&token=2b403c92-7d50-45d2-b049-20c6f8285a3e",
    deploy_name_1: "NETLIFY",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/todos-proyect",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://to-do-pendings.netlify.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
  },
  //id.5 PENDINGS LIST
  {
    id: 5,
    project_name: `${myOtherProjects.id_5_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F13.listapendientes.png?alt=media&token=f9b6442c-b765-4c5b-8df4-a5f9fa8a8c0f",
    alt: "pendings list",
    desc: `${myOtherProjects.id_5_desc}`,
    href: "https://lista-de-pendientes.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/lista-pendientes",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://lista-de-pendientes.vercel.app/",

    // aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    // aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    // seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Styled Components",

    deployed: true,
    type: "practice",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fstyled-components.png?alt=media&token=934a33d3-3c8f-4ff7-b0b9-2633d24e88ba",
  },
  //id.6 ECOMMERCE API
  {
    id: 6,
    project_name: `${myOtherProjects.id_6_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F14.ecommerce-api-nodejs.png?alt=media&token=8044f2c1-873f-4062-9878-5c9bbead329f",
    alt: "ECOMMERCE API",
    desc: `${myOtherProjects.id_6_desc}`,
    href: "https://documenter.getpostman.com/view/18776636/UVyrUwDa#ddaccc80-4ad1-424b-8eed-d9a450ee10cc",
    //Deployment section

    //HEROKU
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fheroku-svgrepo-com.svg?alt=media&token=593ebd1a-69be-4d19-b884-d843fc131343",
    deploy_name_1: "HEROKU",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/api-ecommerce-finalV",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site:
      "https://documenter.getpostman.com/view/18776636/UVyrUwDa#ddaccc80-4ad1-424b-8eed-d9a450ee10cc",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "NODE JS",
    tech_2_name: "EXPRESS JS",
    tech_3_name: "POSTGRESQL",
    tech_4_name: "JWT",
    tech_5_name: "SEQUELIZE",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnodejs-1-logo-svgrepo-com.svg?alt=media&token=afa3c35d-425a-44d7-95bc-ca797548ba45",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fexpress-svgrepo-com.svg?alt=media&token=0ac98956-4734-4662-92b6-15c83e71408e",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpostgresql-svgrepo-com%20(1).svg?alt=media&token=8294cc05-91ae-49c4-8418-d531fc8ca0b7",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjson-web-tokenlOGO.png?alt=media&token=03ad302b-4933-422a-a6fd-0f0f8984a26a",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fsequelize.svg?alt=media&token=b5ee13d5-bd7e-4a76-8dee-3ee295148458",
  },
  //id.7 MOVIES API
  {
    id: 7,
    project_name: `${myOtherProjects.id_7_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F15.movies-api.png?alt=media&token=735ac705-e4ea-432f-9061-6916db43f7b6",
    alt: "MOVIES API",
    desc: `${myOtherProjects.id_7_desc}`,
    href: "https://github.com/OzkrMebasser/movies_api-academlo",
    //Deployment section

    //NOT DEPLOYED
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnot-deployed.jpeg?alt=media&token=2d58e536-9d9d-4e7e-a381-73dd0b370d9c",
    deploy_name_1: "",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/movies_api-academlo",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnot-www.jpeg?alt=media&token=a45def39-4a0f-4569-bbcd-f33a1f3c5319",
    www_site: "https://github.com/OzkrMebasser/movies_api-academlo",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "NODE JS",
    tech_2_name: "EXPRESS JS",
    tech_3_name: "POSTGRESQL",
    tech_4_name: "JWT",
    tech_5_name: "SEQUELIZE",
    tech_6_name: "FIREBASE",

    deployed: false,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnodejs-1-logo-svgrepo-com.svg?alt=media&token=afa3c35d-425a-44d7-95bc-ca797548ba45",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fexpress-svgrepo-com.svg?alt=media&token=0ac98956-4734-4662-92b6-15c83e71408e",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fpostgresql-svgrepo-com%20(1).svg?alt=media&token=8294cc05-91ae-49c4-8418-d531fc8ca0b7",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjson-web-tokenlOGO.png?alt=media&token=03ad302b-4933-422a-a6fd-0f0f8984a26a",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fsequelize.svg?alt=media&token=b5ee13d5-bd7e-4a76-8dee-3ee295148458",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ffirebase-svgrepo-com.svg?alt=media&token=ea3cf79a-0fa3-4a32-ae04-89625cdaa904",
  },
  //id.8 TRIE TREE AUTOCOMPLETE
  {
    id: 8,
    project_name: `${myOtherProjects.id_8_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F16.autocomplete-trietree.png?alt=media&token=c9d2ee9f-5ae9-4a44-b61b-28164aa35b21",
    alt: "TRIE TREE AUTOCOMPLETE",
    desc: `${myOtherProjects.id_8_desc}`,
    href: "https://trie-tree-autocomplete-ds-alg.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/trie-tree-autocomplete-DS-ALG",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://trie-tree-autocomplete-ds-alg.vercel.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "JAVASCRIPT",
    tech_2_name: "Styled Components",
    tech_3_name: "REACT JS",
    tech_4_name: "REACT ROUTER",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fstyled-components.png?alt=media&token=934a33d3-3c8f-4ff7-b0b9-2633d24e88ba",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
  },
  //id.9 HANOI TOWER (STACK)
  {
    id: 9,
    project_name: `${myOtherProjects.id_9_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F17.hanoitower.png?alt=media&token=29f78598-5889-45f6-a0df-fa0e58f18516",
    alt: "HANOI TOWER (STACK)",
    desc: `${myOtherProjects.id_9_desc}`,
    href: "https://hanoi-tower-data-structures.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/hanoi-tower-DS-ALG",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://hanoi-tower-data-structures.vercel.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "JAVASCRIPT",
    tech_2_name: "REACT BOOTSTRAP",
    tech_3_name: "REACT JS",
    tech_4_name: "REACT CONFETTI",

    deployed: true,
    type: "academic",

    /*Icons images*/

    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-bootstrap.png?alt=media&token=b6abc8af-2a82-422e-9898-2c3e31a72e51",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FREACTCONFETTI.png?alt=media&token=8f1713fb-dd5a-49c3-bae4-ad102733febd",
  },
  //id.10 SCHOOL WEBSITE MOCKUP
  {
    id: 10,
    project_name: `${myOtherProjects.id_10_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F18.kairoschool.png?alt=media&token=09377195-8ce9-4b5c-a332-4ff95c1d81d7",
    alt: "SCHOOL WEBSITE MOCKUP",
    desc: `${myOtherProjects.id_10_desc}`,
    href: "https://kairos-riviera-maya-school.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/Kairos-Riviera-Maya",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://kairos-riviera-maya-school.vercel.app/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "Tailwind CSS",

    deployed: true,
    type: "practice",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Ftailwind-svgrepo-com.svg?alt=media&token=de41409e-f0e5-4784-96fa-524c7a31c626",
  },
  //id.11 ROMANS NUMERAL CONVERTER
  {
    id: 11,
    project_name: `${myOtherProjects.id_11_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F19.romannumeralconverter.png?alt=media&token=b959a262-2513-4807-814a-13c112611cda",
    alt: "ROMANS NUMERAL CONVERTER",
    desc: `${myOtherProjects.id_11_desc}`,
    href: "https://convert-roman-nums-to-decimal-syst.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/ConvertRomanNumsToDecimalSyst",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://convert-roman-nums-to-decimal-syst.vercel.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "React Bootstrap",
    tech_6_name: "Redux",

    deployed: true,
    type: "academic",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-bootstrap.png?alt=media&token=b6abc8af-2a82-422e-9898-2c3e31a72e51",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fredux-svgrepo-com.svg?alt=media&token=f19b4bf6-6c39-4d25-96a3-196405d05641",
  },
  //id.12 TECHIES TRIVIA (VANILLA JS)
  {
    id: 12,
    project_name: `${myOtherProjects.id_12_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F20.techiesgame.png?alt=media&token=e4c50d7a-38c1-4d09-98b2-758ca4f4c209",
    alt: "TECHIES GAME (VANILLA JS)",
    desc: `${myOtherProjects.id_12_desc}`,
    href: "https://trivia-techies.netlify.app/",
    //Deployment section

    //NETLIFY
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnetlify-svgrepo-com.svg?alt=media&token=2b403c92-7d50-45d2-b049-20c6f8285a3e",
    deploy_name_1: "NETLIFY",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/Trivia-Techies",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://trivia-techies.netlify.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",

    deployed: true,
    type: "academic",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
  },
  //id.13 PORTOFOLIO MOCKUP
  {
    id: 13,
    project_name: `${myOtherProjects.id_13_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F21.myportfolio.jsvanilla.png?alt=media&token=f99f17fd-edf5-4454-939e-36c65c2c35c4",
    alt: "PORTOFOLIO MOCKUP (VANILLA JS)",
    desc: `${myOtherProjects.id_13_desc}`,
    href: "https://portfolio-oscar-moreno.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/OscarMoreno-Portfolio",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://portfolio-oscar-moreno.vercel.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",

    deployed: true,
    type: "academic",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
  },
  //id.14 EXPENSES CONTROL APP
  {
    id: 14,
    project_name: `${myOtherProjects.id_14_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F22.controldegastosapp.png?alt=media&token=6c2fef8d-6648-4840-8450-f6402781a0f5",
    alt: "EXPENSES CONTROL APP",
    desc: `${myOtherProjects.id_14_desc}`,
    href: "https://control-de-gastos-practice.netlify.app/",
    //Deployment section

    //NETLIFY
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnetlify-svgrepo-com.svg?alt=media&token=2b403c92-7d50-45d2-b049-20c6f8285a3e",
    deploy_name_1: "NETLIFY",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/control-de-gastos-practice",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://control-de-gastos-practice.netlify.app/",

    aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",

    deployed: true,
    type: "practice",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
  },
  //id.15 CONTACTS APP REACT ROUTER V6
  {
    id: 15,
    project_name: `${myOtherProjects.id_15_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F23.contactsconrouter.png?alt=media&token=15de8df1-e908-4fdb-8a2e-89f371165b1f",
    alt: "CONTACTS APP REACT ROUTER V6",
    desc: `${myOtherProjects.id_15_desc}`,
    href: "https://contacts-react-router-v6.netlify.app/",
    //Deployment section

    //NETLIFY
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnetlify-svgrepo-com.svg?alt=media&token=2b403c92-7d50-45d2-b049-20c6f8285a3e",
    deploy_name_1: "NETLIFY",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/contacts-react-router-v6",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://contacts-react-router-v6.netlify.app/",

    // aliasInstitutionName: `${myOtherProjects.aliasInstitutionName}`,
    // aliasInstitutionTitle: `${myOtherProjects.aliasInstitutionTitle}`,
    // seeCert: `${myOtherProjects.seeCert}`,

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React Js",
    tech_5_name: "REACT router",

    deployed: true,
    type: "practice",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-router-svgrepo-com.svg?alt=media&token=75893829-0a4a-4df9-a8ed-27e47c6dbb65",
  },
  //id.16 MEMORY CARD GAME / JUEGO DE TARJETAS DE MEMORIA
  {
    id: 16,
    project_name: `${myOtherProjects.id_16_project_name}`,
    src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FotherProjects%2F24.memorygame.png?alt=media&token=c93fc6d5-2b04-4fe7-bbc2-d69e3527cd3d",
    alt: "MEMORY CARD GAME",
    desc: `${myOtherProjects.id_16_desc}`,
    href: "https://memory-card-game-snowy-alpha.vercel.app/",
    //Deployment section

    //VERCEL
    deploy_icon_1:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
    deploy_name_1: "VERCEL",
    // git hub repo
    git_icon: "https://www.svgrepo.com/show/217753/github.svg",
    git_url: "https://github.com/OzkrMebasser/memory-card-game",
    git_name: "Git repository",
    www_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
    www_site: "https://memory-card-game-snowy-alpha.vercel.app/",

    //Stack I used Section
    /*Icons alt names*/
    tech_1_name: "HTML-5",
    tech_2_name: "CSS-3",
    tech_3_name: "JavaScript",
    tech_4_name: "React JS",
    tech_5_name: "Redux",
    tech_6_name: "Project IDX",

    deployed: true,
    type: "practice",

    /*Icons images*/
    tech_1_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
    tech_2_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
    tech_3_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
    tech_4_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
    tech_5_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fredux-logo-svgrepo-com.svg?alt=media&token=12531cdc-c737-43e7-9494-bacab532fd09",
    tech_6_icon:
      "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FprojectIDX.jpg?alt=media&token=d9fbd8bb-bab7-469d-aa62-4edf7584b7eb",
  },
];

// //id.10 RESURRECTION MIRACLE CENTER CHURCH ******WORKING ON IT ******
// {
//   id: 10,
//   project_name: `${myProjects.id_10_project_name}`,
//   src: "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2F6.tripytour.blog.png?alt=media&token=5b8792fd-cbd8-44a5-8a58-c3a140922c24",
//   alt: "TRIPYTOUR BLOG",
//   desc: `${myProjects.id_10_desc}`,
//   href: "https://tripytour-blog.vercel.app/",

//   //Deployment section

//   //Vercel
//   deploy_icon_1:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fvercel-icon-svgrepo-com.svg?alt=media&token=d8d668a2-26f0-4103-a3ae-99e6d3c31103",
//   deploy_name_1: "Vercel",
//   // git hub repo
//   git_icon: "https://www.svgrepo.com/show/217753/github.svg",
//   git_url: "https://github.com/OzkrMebasser/tripytour-blog",
//   git_name: "Git repository",
//   www_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Finternet-www-svgrepo-com.svg?alt=media&token=49e3d743-fa07-4bdc-879e-0e99c87df52e",
//   www_site: "https://tripytour-blog.vercel.app/",

//   //Stack I used Section
//   /*Icons alt names*/
//   tech_1_name: "HTML-5",
//   tech_2_name: "CSS-3",
//   tech_3_name: "JavaScript",
//   tech_4_name: "React Js",
//   tech_5_name: "Next Js",
//   tech_6_name: "Prisma",
//   tech_7_name: "MongoDB",

//   deployed: true,
//   type: "development",

//   /*Icons images*/

//   tech_1_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fhtml-svgrepo-com.svg?alt=media&token=bf007597-213f-410e-b369-8035584a3ad7",
//   tech_2_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fcss-svgrepo-com.svg?alt=media&token=05933c42-aa37-4123-a959-dd7ace7fb4b8",
//   tech_3_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fjs-svgrepo-com.svg?alt=media&token=c6b39548-7d54-4dfc-8720-5a500786edda",
//   tech_4_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Freact-1-logo-svgrepo-com.svg?alt=media&token=f690f37d-9457-4a0b-8378-16a7d426114f",
//   tech_5_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fnext-js-svgrepo-com.svg?alt=media&token=ac7b37d1-13b5-4c9e-8986-6f6eb1123f31",
//   tech_6_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2FPRISMA.png?alt=media&token=fc59e78c-6885-4d82-9243-076c630c983e",
//   tech_7_icon:
//     "https://firebasestorage.googleapis.com/v0/b/oscar-moreno-dev.appspot.com/o/oscar-portfolio-imgs%2FProjects%2FTech-Icons%2Fmongodb-svgrepo-com.svg?alt=media&token=12d49f5f-5031-43e4-abd8-aa14ae07565a",
// },
